import type {
  GridPaginationModel,
  GridRowSelectionModel,
  GridSortModel,
} from '@mui/x-data-grid-pro';
import { useCallback, useState } from 'react';
import { useLocalOrderBy } from '~/hooks/order-by';

export const useSelectableList = <T extends string>({
  initialSort,
}: {
  initialSort: GridSortModel;
}) => {
  const [search, setSearch] = useState('');

  const { orderBy, sortModel, setSortModel } = useLocalOrderBy<T>(initialSort);

  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 50,
  });

  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const handleSelectionChange = useCallback(
    (currentPageIds: number[]) => (newSelection: GridRowSelectionModel) => {
      const selectedOnPage = newSelection.map(Number);
      const offPageSelected = selectedIds.filter((id) => !currentPageIds.includes(id));
      setSelectedIds([...new Set([...offPageSelected, ...selectedOnPage])]);
    },
    [selectedIds],
  );

  const clearSelected = useCallback(() => setSelectedIds([]), []);

  return {
    search,
    setSearch,
    sortModel,
    setSortModel,
    orderBy,
    paginationModel,
    setPaginationModel,
    selectedIds,
    handleSelectionChange,
    clearSelected,
  };
};
